export function trackEvent(data) {
  const { proxy } = useScriptGoogleTagManager();

  proxy.dataLayer.push({ ...data });
}
